import { IAPIResponse } from "../interfaces/api";
import { IGameDraftCreateResponse, IGameDraftDeleteResponse, IGameDraftUpdateResponse, IGameInfo } from "../interfaces/game-info";
import { config } from "../utils/config";
import { log } from "../utils/logger";
import { formatURL } from "../utils/utils";

export const getDraftList = async <Type>(lanid: string): Promise<IAPIResponse<Array<Type>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/draft/list?userName=${lanid}`;
    const headers = new Headers();

    log.debug(`getDraftList HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const createDraft = async (lanid: string, gameInfo: IGameInfo): Promise<IAPIResponse<IGameDraftCreateResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/create?userName=${lanid}`;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    log.debug(`createDraft HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify(gameInfo) });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const updateDraft = async (lanid: string, gameInfo: IGameInfo): Promise<IAPIResponse<IGameDraftUpdateResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/update?userName=${lanid}`;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    log.debug(`createDraft HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify(gameInfo) });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const deleteDraft = async (lanid: string, gameName: string): Promise<IAPIResponse<IGameDraftDeleteResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/draft/delete/${gameName}?userName=${lanid}`;
    const headers = new Headers();

    log.debug(`deleteDraft HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'DELETE', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}